module.exports = __webpack_public_path__ + "static/media/card-profile1.a0949f48.jpg";